import React from "react";

// TODO: this can be replaced around the app with the SelectField component
// but that means it should always be wrapped in a Formik context

export default function ReusableDropdown({
  title,
  selectedDropdown,
  list,
  handleDropdown,
  className,
}) {
  // selectValue => current selected value
  // filterData => choices in the dropdown
  // setFilteredData => function to change the selectValue

  function handleChange(e) {
    // console.log(e.target.value)
    handleDropdown(e.target.value);
  }
  return (
    <div className="dropdown-container">
      <select
        className={className}
        value={selectedDropdown}
        onChange={(e) => handleChange(e)}
        style={{ paddingLeft: "17px" }}
      >
        <option hidden>{title}</option>
        {list.map((data) => {
          return (
            <option
              style={{ paddingLeft: "17px", fontSize: 12 }}
              key={data}
              value={data}
            >
              {data}
            </option>
          );
        })}
      </select>
      <i className="dropdown-icon fas fa-sort-down"></i>
    </div>
  );
}
